import clientInformation, { getClientItem } from '../login/ClientInfo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faNetworkWired } from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Alerts from '../helpers/Alerts';
import { IsValidToken, GetCustomerInfo, CheckCustomerData } from "../../services/AuthenticationService";
import { onlyNumbers, BonusString } from '../helpers/common';
import { isMobile } from 'react-device-detect';
import Bonus from '../Bonus';
import Loading from '../helpers/Loader'
import { MissingAccountInfo } from "../deposit/MissingAccountInfo.jsx";
import { useTranslations } from '../../context/LanguageContext';
import translations from '../../translations/ECheckMethods';

export const ECheckMethods = () => {
    const t = useTranslations(translations);

    const clientInfo = clientInformation();
    let MAXLIMIT = process.env.REACT_APP_MaxLimit;
    let INSTANCEID = clientInfo.InstanceID;
    const [isLoading, setIsLoading] = useState(true);
    const [isValidate, setIsValidate] = useState(true);
    const navigate = useNavigate();
    const [arrayCustomerInfo, setArrayCustomerInfo] = useState([]);
    const [arrayRegularDeposits, setRegularDeposits] = useState(JSON.parse(getClientItem('ArrayRegularMethods')).filter(function (element) { return element.DepositID == 'Check'; })[0]);
    const [isProcessing, setIsProcessing] = useState(false);
    const fixedAmount = Number(getClientItem('FixedAmount')) || 0;
    const [amount, setAmount] = useState(fixedAmount > 0 ? fixedAmount : '');

    useEffect(() => {
        IsValidToken(getClientItem('Token')).then(async function () {
            doCheckCustomerData();

            setIsLoading(false);
        })
            .catch(function (error) {
                setIsLoading(false);
                navigate('/expired/');
            })
        CustomerInfo();
    }, [])

    async function doCheckCustomerData() {
        await CheckCustomerData(getClientItem('Token'), 'check').then(async function (response) {
            if (!response.Authentication.AllComplete) {
                setIsValidate(true);
            }
            else {
                setIsValidate(false);
            }
        })
    };

    async function CustomerInfo() {
        await GetCustomerInfo(getClientItem('Token')).then(function (response) {
            if (response.Authentication.ErrorDescription != "Invalid input data") {
                setArrayCustomerInfo(response.Authentication);

            }
            else {

                Alerts.ShowAlert(t.error, t.errorGettingCustomerInfo + response.Authentication.ErrorDescription, 'error');

            }
        })
            .catch(function (error) {

                Alerts.ShowAlert(t.error, t.errorGettingCustomerInfo + error.response.data.Authentication.ErrorDescription, 'error');
            })
    }

    function handleResponseFromComponent(response) {
        setIsValidate(response);
    }

    if (isValidate) {
        return <MissingAccountInfo Processor={'crypto'} isValidate={handleResponseFromComponent.bind(isValidate)} />;
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!isProcessing) {
            var data = new FormData(event.target);
            let { amount, accountoremail, secureid } = Object.fromEntries(data.entries());
            if (amount != '') {
                setIsProcessing(true);

                setIsProcessing(false);
            }
            else {
                Alerts.ShowAlert(t.warning, t.amountRequired, 'warning');
            }
        }
    }

    return (
        <div className="componentload">
            <form onSubmit={handleSubmit}>
                <div className="row m-4">
                    <span className="icon-single-left txt-primary">
                        <img style={{ width: "100px", height: "100px" }} src={"/svg/" + arrayRegularDeposits.ImageName + ".svg"} /> {t.depositUsing}
                    </span>
                </div>
                <div className="row">
                    <div className="col-md-1 d-none d-md-block"></div>
                    <div className="col-md-10 col-sm-12">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="input-group mb-3  ">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-currency-cards d-none d-md-block" id="lblCurrency">
                                                <select className="form-control selectcurrency" disabled name="CurrencyCode" required="" value={clientInfo.CurrencyCode == 'mBTC' ? 'USD' : clientInfo.CurrencyCode}>
                                                    <option value="" className="">{t.currency}</option>
                                                    <option selected value="USD">USD</option>
                                                    <option value="EUR">EUR</option>
                                                    <option value="GBP">GBP</option>
                                                    <option value="CAD">CAD</option>
                                                </select>
                                            </span>
                                        </div>
                                        <input type="number" onKeyPress={(event) => onlyNumbers(event)} aria-label="Amount (to the nearest dollar)" className="form-control" id="amount" aria-describedby="lblCurrency" placeholder={t.amount} max={arrayRegularDeposits?.MaxDeposit === 0 ? MAXLIMIT : arrayRegularDeposits?.MaxDeposit} min={arrayRegularDeposits?.MinDeposit === 0 ? 1 : arrayRegularDeposits?.MinDeposit} name="amount" required="" value={amount} onChange={(e) => setAmount(e.target.value)} readOnly={fixedAmount > 0} />
                                    </div>
                                </div>
                                <div className="d-flex flex-row ml-2 limit-text-center mb-4 ">
                                    {t.depositLimits} {arrayRegularDeposits.MinDeposit == 0 ? 1 : arrayRegularDeposits.MinDeposit} USD {t.maximum} {arrayRegularDeposits.MaxDeposit == 0 ? t.noLimit : arrayRegularDeposits.MaxDeposit + ' USD'}
                                </div>
                            </div>
                            <div className="col-md-6  mb-3">
                                <label class="d-md-none mb-3">{t.accountType}</label>
                                <select class="form-control form-select border-teal" name="accounttype" aria-label={t.accountType} placeholder={t.accountType} required="">
                                    <option value="PC" selected="selected">{t.personalChecking}</option>
                                    <option value="PS">{t.personalSavings}</option>
                                    <option value="CC">{t.commercialChecking}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-1 d-none d-md-block"></div>
                </div>
                <div className="row">
                    <div className="col-md-1 d-none d-md-block"></div>
                    <div className="col-md-10 col-sm-12">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="row  mb-3">
                                    <label for="country" className="col-md-4 col-sm-12">{t.routingNumber}:</label>
                                    <div className="col-md-8 col-sm-12 ">
                                        <input type="text" class="form-control color-gray border-teal" name="RoutingNumber" aria-label="RoutingNumber" placeholder={t.routingNumberPlaceholder} maxlength="50" required="" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row  mb-3">
                                    <label for="state" className="col-md-4 col-sm-12">{t.accountNumber}:</label>
                                    <div className="col-md-8 col-sm-12">
                                        <input type="text" class="form-control color-gray border-teal" name="AccountNumber" aria-label="AccountNumber" placeholder={t.accountNumber} maxlength="50" required="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-1 d-none d-md-block"></div>
                </div>
                <div className="row">
                    <div className="col-md-1 d-none d-md-block"></div>
                    <div className="col-md-10 col-sm-12">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="row  mb-3">
                                    <label for="bankname" className="col-md-4 col-sm-12">{t.bankName}:</label>
                                    <div className="col-md-8 col-sm-12 ">
                                        <input type="text" class="form-control color-gray border-teal" name="bankname" aria-label={t.bankName} placeholder={t.bankNamePlaceholder} maxlength="30" required="" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row  mb-3">
                                    <label for="Firstname" className="col-md-4 col-sm-12">{t.firstName}:</label>
                                    <div className="col-md-8 col-sm-12">
                                        <input type="text" class="form-control color-gray border-teal" name="Firstname" aria-label="Firstname" placeholder={t.firstNamePlaceholder} maxlength="30" value={arrayCustomerInfo.Name} required="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-1 d-none d-md-block"></div>
                </div>
                <div className="row">
                    <div className="col-md-1 d-none d-md-block"></div>
                    <div className="col-md-10 col-sm-12">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="row  mb-3">
                                    <label for="Lastname" className="col-md-4 col-sm-12">{t.lastName}:</label>
                                    <div className="col-md-8 col-sm-12 ">
                                        <input type="text" class="form-control color-gray border-teal" name="Lastname" aria-label="Lastname" placeholder={t.lastNamePlaceholder} maxlength="30" value={arrayCustomerInfo.LastName} required="" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row  mb-3">
                                    <label for="City" className="col-md-4 col-sm-12">{t.city}:</label>
                                    <div className="col-md-8 col-sm-12">
                                        <input type="text" class="form-control color-gray border-teal" name="City" aria-label="City" placeholder={t.city} maxlength="20" value={arrayCustomerInfo.City} required="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-1 d-none d-md-block"></div>
                </div>
                <div className="row">
                    <div className="col-md-1 d-none d-md-block"></div>
                    <div className="col-md-10 col-sm-12">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="row  mb-3">
                                    <label for="Address" className="col-md-4 col-sm-12">{t.address}:</label>
                                    <div className="col-md-8 col-sm-12 ">
                                        <input type="text" class="form-control color-gray border-teal" name="Address" aria-label="Address" placeholder={t.address} maxlength="50" value={arrayCustomerInfo.Address} required="" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row  mb-3">
                                    <label for="Address2" className="col-md-4 col-sm-12">{t.address2}:</label>
                                    <div className="col-md-8 col-sm-12">
                                        <input type="text" class="form-control color-gray border-teal" name="Address2" aria-label="Address2" placeholder={t.address2Placeholder} maxlength="50" value={arrayCustomerInfo.Address2} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-1 d-none d-md-block"></div>
                </div>
                <div className="row">
                    <div className="col-md-1 d-none d-md-block"></div>
                    <div className="col-md-10 col-sm-12">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="row  mb-3">
                                    <label for="country" className="col-md-4 col-sm-12">{t.country}:</label>
                                    <div className="col-md-8 col-sm-12 ">
                                        <input type="text" className="form-control color-gray border-teal" name="country" aria-label="country" value={arrayCustomerInfo.Country} placeholder={arrayCustomerInfo.Country == '' ? t.country : arrayCustomerInfo.Country} disabled="disabled" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row  mb-3">
                                    <label for="state" className="col-md-4 col-sm-12">{t.stateProv}:</label>
                                    <div className="col-md-8 col-sm-12">
                                        <input type="text" className="form-control color-gray border-teal" name="state" aria-label="state" value={arrayCustomerInfo.State} placeholder={arrayCustomerInfo.State == '' ? t.stateProv : arrayCustomerInfo.State} disabled="disabled" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-1 d-none d-md-block"></div>
                </div>
                <div className="row">
                    <div className="col-md-1 d-none d-md-block"></div>
                    <div className="col-md-10 col-sm-12">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="row  mb-3">
                                    <label for="ZipCode" className="col-md-4 col-sm-12">{t.zip}:</label>
                                    <div className="col-md-8 col-sm-12 ">
                                        <input type="text" class="form-control color-gray border-teal" name="ZipCode" aria-label="ZipCode" placeholder={t.zipCode} maxlength="12" value={arrayCustomerInfo.ZipCode} required="" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row  mb-3">
                                    <label for="Phone" className="col-md-4 col-sm-12">{t.phone}:</label>
                                    <div className="col-md-8 col-sm-12">
                                        <input type="text" class="form-control color-gray border-teal" name="Phone" aria-label="Phone" placeholder={t.phone} maxlength="20" value={arrayCustomerInfo.Phone} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-1 d-none d-md-block"></div>
                </div>
                <div className="row">
                    <div className="col-md-1 d-none d-md-block"></div>
                    <div className="col-md-10 col-sm-12">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="row  mb-3">
                                    <label for="ZipCode" className="col-md-4 col-sm-12">{t.email}:</label>
                                    <div className="col-md-8 col-sm-12 ">
                                        <input type="text" class="form-control color-gray border-teal" name="Email" aria-label="Email" placeholder={t.email} maxlength="12" value={arrayCustomerInfo.Email} required="" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row  mb-3">
                                    <label for="Phone" className="col-md-4 col-sm-12">{t.description}:</label>
                                    <div className="col-md-8 col-sm-12">
                                        <input type="text" class="form-control color-gray border-teal" name="Description" aria-label="Description" placeholder={t.description} maxlength="20" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-1 d-none d-md-block"></div>
                </div>
                <Bonus />
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12 " >

                    </div>
                    <div className="col-md-12 mb-3-small mt-4 actionbuttons">
                        <button type="button" className="btn btn-secondary btn-gray btn-back-order mb-4" onClick={() => navigate('/deposits/')}>{t.back}</button>
                        <button type="submit" className="btn btn-deposit btn-deposit-order mb-4 submit">{t.deposit}</button>
                    </div>
                </div>
            </form>
        </div>
    );

}
